export const FORM_NAME = "register";
export const STATE_NAME = "registerScreen";
